export default __webpack_public_path__ + "static/media/2275.a2e3c75b.png";